import * as React from 'react';
require('./style.css');

type IProps = React.PropsWithChildren<{
	onClick?: any;
	variant?: 'green' | 'white' | 'black';
	holderRef?: React.RefObject<HTMLDivElement>;
}>;

export class SectionTitle extends React.Component<IProps> {
	private textRef: React.RefObject<HTMLDivElement>;
	private holderRef: React.RefObject<HTMLDivElement>;

	constructor(props: IProps) {
		super(props);

		this.textRef = React.createRef<HTMLDivElement>();
		this.holderRef = React.createRef<HTMLDivElement>();

		this.onScroll = this.onScroll.bind(this);
		this.getRef = this.getRef.bind(this);
	}

	public componentDidMount() {
		window.addEventListener('scroll', this.onScroll);
		document.addEventListener('resize', this.onScroll);
	}

	public componentWillUnmount() {
		window.removeEventListener('scroll', this.onScroll);
		document.removeEventListener('resize', this.onScroll);
	}

	private getRef(): React.RefObject<HTMLDivElement> {
		return this.props.holderRef || this.holderRef;
	}

	private onScroll() {
		const holder = this.getRef().current;
		if (!holder || !this.textRef.current) {
			return;
		}
		const top = Math.min(0, holder.getBoundingClientRect().top);
		this.textRef.current.style.top = String(-top) + 'px';
	}

	public render() {
		const { onClick, children, variant } = this.props;
		const onTitleClick = (e) => {
			if (onClick) {
				onClick(e);
			}
		};

		return (
			<div className={`sectionTitle ${variant || 'green'}`} onClick={(e) => onTitleClick(e)} ref={this.getRef()}>
				<div ref={this.textRef}>{children}</div>
			</div>
		);
	}
}
